import { injectIntl } from 'react-intl';
import Translated from './Translated';

export default injectIntl(Translated, { withRef: false });
